const staging = `https://stagingapi.eurekalogistics.co.id/`;
const production = `https://apirace.eurekagroup.id/`;
export const BaseUrlRace = `https://apirace.eurekagroup.id/`;
const Baseurl = production;
// const Baseurl = process.env.REACT_APP_API_URL;
export default Baseurl;

//DEVELOPMENT
// const staging = `https://smartrace-backend-dev-197338735518.asia-southeast2.run.app/`;
// const production = `https://smartrace-backend-dev-197338735518.asia-southeast2.run.app/`;
// export const BaseUrlRace = `https://smartrace-backend-dev-197338735518.asia-southeast2.run.app/`;
// const Baseurl = production;
// // const Baseurl = process.env.REACT_APP_API_URL;
// export default Baseurl;

// const staging = `http://localhost:2026/`;
// const production = `http://localhost:2026/`;
// export const BaseUrlRace = `http://localhost:2026/`;
// const Baseurl = production;
// // const Baseurl = process.env.REACT_APP_API_URL;
// export default Baseurl;
